/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export const usePDPSearchParams = (productId) => {
    const allParams = new URLSearchParams()
    const productParams = new URLSearchParams(allParams.get(productId) || '')

    return [allParams, productParams]
}
